import { call, put, fork, takeLatest } from 'redux-saga/effects'
import * as ActionTypes from '../modules/ActionTypes';
import {wirteFeedback,getFeedback,getEvent,wirteEvent} from '../services/feedback';

function* callGetEvent(action) {
    const { response, error } =  yield call(getEvent, action.payload);

    if (response) {
        yield put({type: ActionTypes.GET_EVENT.SUCCESS, payload: { response }});
    } else {
        yield put({type: ActionTypes.GET_EVENT.FAILURE, payload: { error }});
        console.error('[ERROR][getEvent]', error)
    }
}

function* callWirteEvent(action) {
    const { response, error } =  yield call(wirteEvent, action.payload);

    if (response) {
        yield put({type: ActionTypes.WRITE_EVENT.SUCCESS, payload: { response }});
    } else {
        yield put({type: ActionTypes.WRITE_EVENT.FAILURE, payload: { error }});
        console.error('[ERROR][wirteEvent]', error)
    }
}

function* callGetFeedback(action) {
    const { response, error } =  yield call(getFeedback, action.payload);

    if (response) {
        yield put({type: ActionTypes.GET_FEEDBACK.SUCCESS, payload: { response }});
    } else {
        yield put({type: ActionTypes.GET_FEEDBACK.FAILURE, payload: { error }});
        console.error('[ERROR][getFeedback]', error)
    }
}

function* callWirteFeedback(action) {
    const { response, error } =  yield call(wirteFeedback, action.payload);

    if (response) {
        yield put({type: ActionTypes.WRITE_FEEDBACK.SUCCESS, payload: { response }});
    } else {
        yield put({type: ActionTypes.WRITE_FEEDBACK.FAILURE, payload: { error }});
        console.error('[ERROR][wirteFeedback]', error)
    }
}

function* watchGet() {
	yield takeLatest(ActionTypes.WRITE_EVENT.REQUEST, callWirteEvent);
	yield takeLatest(ActionTypes.GET_EVENT.REQUEST, callGetEvent);
    yield takeLatest(ActionTypes.WRITE_FEEDBACK.REQUEST, callWirteFeedback);
	yield takeLatest(ActionTypes.GET_FEEDBACK.REQUEST, callGetFeedback);
}

export default function* feedbackSaga() {
    yield fork(watchGet);
}